<script>
import FortuneWheel from 'vue-fortune-wheel';
import 'vue-fortune-wheel/lib/vue-fortune-wheel.css';

export default {
	name: 'Spinwheel',
	components: {FortuneWheel},
	data() {
		return {
			// Canvas options for the spinwheel border
			canvasOptions: {
				borderWidth: 6,
				borderColor: '#FFF'
			},
			// Prize data for the wheel
			prizes: [],
			// Enable verification before spinning
			canvasVerify: true,
			modalSpinwheel: false,
			spinWheelData: {},
			agree: false,
			userEmail: '',
			spinwinInstance: null,
			isEmailValid: false,
			emailErrorMessage: '',
			pickedRewardId: -1,
			showLuckMessage: false,
			luckMessage: '',
			luckMessageSuffix: '',
			spinWheelPrize: null,
			isSpinDisabled: true,
			showWheel: false,
			showField: true,
			showMessages: false,
			wheelStart: false,
		};
	},
	mounted() {
		this.toggleModal();
		this.modalSpinwheel = true;
		this.getSpinwinInstance();

	},

	onComputed() {
		this.$store.dispatch('spinwheel/fetchSpinWheelData');

	},
	methods: {
		// Called when the spin starts

		async getSpinwinInstance() {
			try {
				const response = await axios.post('/api/get-spinwin-metadata');
				this.spinwinInstance = response.data;
				if (!this.spinwinInstance.coupons || this.spinwinInstance.coupons.length == 0) {
					this.closeModal();
					return;
				}
				this.prizes = this.spinwinInstance.coupons.map((coupon) => {

						// if there is no short description specified, take the normal description to display
						const sliceName = (typeof coupon.short_description === 'string' && coupon.short_description)
							? coupon.short_description
							: coupon.description;

						return {
							id: coupon.id,
							value: sliceName,
							name: sliceName,
							description: coupon.description,
							probability: coupon.probability * 1,
							bgColor: coupon.bg_color,
							color: coupon.color
						}
					}
				);
				if (this.spinwinInstance.no_coupon) {
					this.prizes.push({
						id: this.spinwinInstance.no_coupon.id,
						name: this.spinwinInstance.no_coupon.name,
						value: this.spinwinInstance.no_coupon.value,
						probability: this.spinwinInstance.no_coupon.probability * 1,
						bgColor: this.spinwinInstance.no_coupon.bg_color,
						color: this.spinwinInstance.no_coupon.color
					});
				}
				this.showWheel = true;
			} catch (error) {
				console.error('Error fetching Spinwin instance:', error.response.data.message)
			}
		},

		async validateUserCredentials() {
			if (this.userEmail == null || this.userEmail.length === 0) {
				return;
			}
			try {
				const response = await axios.post('/api/verify-play-credentials', {
					spinwin_id: this.spinwinInstance.id,
					email: this.userEmail
				})
				if (response.data.success) {
					this.isEmailValid = true;
					this.isSpinDisabled = false;
				} else {
					this.isEmailValid = false;
					this.emailErrorMessage = response.data.error;
					this.showMessages = true;
				}
				this.showField = false;
			} catch (error) {
				this.emailErrorMessage = error.response.data.error;
				console.error('Error validating user:', error.response.data.error);
				this.showField = false;
				this.showMessages = true;
			}
		},

		async generateReward() {
			try {
				const response = await axios.post('/api/play', {
					spinwin_id: this.spinwinInstance.id,
					email: this.userEmail
				})
				this.showMessages = false;
				if (response.data.status) {
					if (response.data.coupon) {
						const couponId = response.data.coupon.id;
						const prize = this.prizes.find(p => p.id === couponId)
						if (prize) {
							this.pickedRewardId = prize.id; // Ensure this is a valid number
						} else {
							this.pickedRewardId = -1; // Use a fallback if prize is not found
						}
					} else {
						this.pickedRewardId = -1;
					}
					// if user actually got the coupon
					if (this.pickedRewardId > -1) {
						this.luckMessage = 'spinwin.success.message';
						this.luckMessageSuffix = 'spinwin.success.suffix.message';
					} else {
						this.luckMessage = 'spinwin.failed.message';
						this.luckMessageSuffix = '';
					}
				}

			} catch (error) {
				console.error('Error generating a reward for wheel spin', error.response.data.message)
			}
		},

		async onCanvasRotateStart(rotate) {
			await this.generateReward();
			rotate();
			this.wheelStart = true;
		},
		// Called when the spin ends
		onRotateEnd(prize) {
			this.showMessages = true;
			this.showLuckMessage = true;
			this.spinWheelPrize = (prize && prize.id && prize.id > 0) ? prize : null;
			this.isSpinDisabled = true;
			this.wheelStart = false;
		},
		// Simulated verification service
		DoServiceVerify(verified, duration) {
			return new Promise((resolve) => {
				setTimeout(() => {
					resolve(verified);
				}, duration);
			});
		},
		toggleModal() {
			this.modalSpinwheel = !this.modalSpinwheel;
			if (this.modalSpinwheel) {
				document.body.classList.add('no-scroll');
			} else {
				document.body.classList.remove('no-scroll');
			}
		},
		closeModal() {
			this.modalSpinwheel = null;
			document.body.classList.remove('no-scroll');
		}
	}
};
</script>

<template>
	<div v-if="modalSpinwheel" class="spinwheel-parent">
		<div class="overlay"></div>
		<div class="togglers-modal-wrapper">
			<div class="modal-wrapper-header">
				<div class="header-title-wrapper">
					<h1 class="spinwin-title">Spin to win</h1>
				</div>
				<button class="btn btn-plain btn-close" @click="toggleModal">
					<svg class="ticon ticon-180">
						<use xlink:href="/images/icons.svg?v1.3#icon-close"></use>
					</svg>
				</button>
			</div>
			<div class="modal-body">
				<div class="spinwin-content" v-bind:class="{ hide: !showField}">
					<p class="luck-message" v-text="$__('spinwin.intro.message')"></p>
					<form class="form" @submit.prevent>
						<input
							type="email"
							v-model="userEmail"
							placeholder="Enter your email"
							required
							class="form-control"
						/>
						<div class="terms-content">
							<label>
								<input type="checkbox" class="terms-checkbox" v-model="agree">
								<span v-html="$__('spinwin.intro.terms.message')"></span>
							</label>
						</div>
					</form>
					<button :disabled="!this.agree" @click="validateUserCredentials()"
							class="btn btn-sm btn-primary"
							v-text="$__('spinwin.intro.button.label')"></button>
					<p>
						<a href="#" @click="toggleModal" class="close-message"
						   v-text="$__('spinwin.intro.close.label')"></a>
					</p>
				</div>
				<div class="message-container" v-bind:class="{ show: showMessages}">
					<div v-if="emailErrorMessage" class="error-wrapper">
						<p class="text-error-message">
							<span>{{ $__(this.emailErrorMessage) }}</span>
						</p>
					</div>
					<div v-if="showLuckMessage" class="message-container">
						<p class="luck-message">
							<span v-text="$__(this.luckMessage)"></span><br />
							<span class="prize" v-if="spinWheelPrize">{{ this.spinWheelPrize.description }}</span><br />
							<span v-text="$__(this.luckMessageSuffix)"></span><br />
						</p>
						<p v-if="!showWheel" class="luck-message" v-text="$__('spinwin.email.sent')"></p>
					</div>
					<!-- FortuneWheel Component with canvas mode -->
				</div>
				<div class="wheel-container" v-bind:class="{ disabled: isSpinDisabled}">
					<FortuneWheel v-if="showWheel"
								  type="canvas"
								  :canvas="canvasOptions"
								  :prizes="prizes"
								  :prizeId="pickedRewardId"
								  :verify="canvasVerify"
								  :disabled="isSpinDisabled"
								  @rotateStart="onCanvasRotateStart"
								  @rotateEnd="onRotateEnd"
					/>
					<p class="wheel-message" v-if="!isSpinDisabled && !wheelStart && !showLuckMessage" v-html="$__('spinwin.wheel.start.message')"></p>
				</div>
			</div>
		</div>
	</div>


</template>

<style scoped>

.form {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}

.modal-wrapper-header {
	width: 100%;
	height: 90px;
	justify-content: end;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	vertical-align: top;
}

.modal-body {
	align-items: center;
	justify-content: center;
	display: flex;
	flex-direction: column;
}

/*.spinwin-title {
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	justify-content: center;
	text-align: center;
	margin: 0;
	width: 95%;
}*/

.header-title-wrapper {
	width: 95%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.spinwin-title {
	padding-top: 10px;
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	text-align: center;
	justify-content: center;
	width: 95%;
	margin: 0;
	color: #fff;
}

.btn-close {
	width: 5%;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		color: #fff;
	}
}

.spinwheel-parent {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%); /* This centers the modal */
	background-color: #000;
	z-index: 100; /* Ensure it's above other elements */
	padding: 20px; /* Optional padding for better appearance */
	max-width: 600px;
	height: 620px;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.message-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 0;
	transition: all 1s;
	transition-behavior: allow-discrete;
	&.show {
		height: 350px;
	}
}

.spinwin-content {
	opacity: 1;
	text-align: center;
	height: 350px;
	overflow: hidden;
	/*transition: height 1s ease-out, display 2s;*/
	transition: all 1s;
	transition-behavior: allow-discrete;

	&.hide {
		height: 0;
		display: none;
	}

	input[type="text"]:focus {
		margin: 0 auto;
		text-align: center;
		outline: none;
	}

	button {
		margin-top: 10px;
	}

	.terms-content {

		text-align: center;

		label {
			padding: 0;
			display: flex;
			flex-direction: row;

			span {
				flex: 1;
			}

			.terms-checkbox {
				margin-top: 5px;
				margin-right: 10px;
				width: 20px;
				height: 20px;
			}

		}


	}

}

.wheel-container {
	margin: 0 auto;
	position: relative;

	.fw-container {
		width: 350px;

		.fw-btn__btn {
			color: #E6007E;
			background-color: #FFFFFF;
			cursor:pointer;
			&:before {
				border-bottom-color: #E6007E;
			}
		}
	}


	&.disabled {
		.fw-container {
			.fw-btn__btn {
				cursor:none;
			}
		}
	}
}

.no-scroll {
	overflow: hidden;
}

.error-wrapper {
	margin-top: 60px;
	height: 200px;
	font-family: "adobe-caslon-pro", serif;
	font-size: 39px;
	color: #FFF;
	text-align: center;
}

.wheel-message {
	margin-top: 60px;
	font-family: "adobe-caslon-pro", serif;
	font-size: 24px;
	color: #FFF;
	text-align: center;
}

.luck-message {
	font-family: "adobe-caslon-pro", serif;
	font-size: 18px;
	color: #FFF;
	margin: 10px;
	text-align: center;

	.prize {
		color: #E6007E;
		font-size: 39px;
	}
}


.terms-content {
	color: #FFF;
}

.close-message {
	color: #767676;
}

.text-error-message {
	color: #FFFFFF;
}


</style>

